export default "__VITE_ASSET__CQ8OzUYQ__"